import type { ProgramFamily } from './context';

export interface VocabularyRecord {
  concept: string;
  canonical: string;
  sah?: string;
  rac?: string;
  other?: Partial<Record<ProgramFamily, string>>;
  shared?: string;
  sahProhibited: readonly string[];
  racProhibited: readonly string[];
  audiences: Partial<Record<'provider' | 'worker' | 'representative', string>>;
  owner: string;
}

export const EXPERIENCE_VOCABULARY: readonly VocabularyRecord[] = [
  {
    concept: 'programme_workspace',
    canonical: 'programme workspace',
    sah: 'Support at Home workspace',
    rac: 'residential aged care workspace',
    shared: 'programme workspace',
    sahProhibited: ['residential programme workspace'],
    racProhibited: ['Support at Home programme workspace'],
    audiences: {},
    owner: 'Platform Experience',
  },
  {
    concept: 'care_recipient',
    canonical: 'care recipient',
    sah: 'client',
    rac: 'resident',
    shared: 'person',
    sahProhibited: ['resident', 'bed', 'room allocation', 'residential admission'],
    racProhibited: ['Support at Home client', 'service area', 'home visit'],
    audiences: { representative: 'person you represent' },
    owner: 'Platform Experience',
  },
  {
    concept: 'service_delivery',
    canonical: 'care delivery',
    sah: 'visit',
    rac: 'round',
    shared: 'care delivery',
    sahProhibited: ['residential round', 'wing round'],
    racProhibited: ['home visit', 'travel-to-client'],
    audiences: { worker: 'care task' },
    owner: 'Care Operations',
  },
  {
    concept: 'financial_evidence',
    canonical: 'financial evidence',
    sah: 'budget, contribution and statement',
    rac: 'fee, accommodation and invoice',
    shared: 'financial evidence',
    sahProhibited: ['RAD', 'DAP', 'accommodation payment'],
    racProhibited: ['quarterly SAH budget', 'SAH contribution category'],
    audiences: { representative: 'fees and statements' },
    owner: 'Finance',
  },
];

export function vocabularyFor(
  concept: string,
  firewallFamily: 'SAH' | 'RAC' | 'SHARED' | 'OTHER' | 'UNKNOWN',
): string | null {
  const record = EXPERIENCE_VOCABULARY.find((item) => item.concept === concept);
  if (!record || firewallFamily === 'UNKNOWN') return null;
  if (firewallFamily === 'SAH') return record.sah ?? null;
  if (firewallFamily === 'RAC') return record.rac ?? null;
  if (firewallFamily === 'SHARED') return record.shared ?? null;
  return record.canonical;
}
